export { default } from "@src/Apps/ProductTerms";
